/** Asia/Jerusalem calendar day, half-open [start, end). */
export const ISRAEL_DAY_START_SQL = `(date_trunc('day', now() AT TIME ZONE 'Asia/Jerusalem') AT TIME ZONE 'Asia/Jerusalem')`;
export const ISRAEL_DAY_END_SQL = `(${ISRAEL_DAY_START_SQL} + interval '1 day')`;

/**
 * Approval instant for an individual seat.
 * approved_at is written on every approval. Older rows fall back to the manager
 * match time, then to registration time.
 */
export const OPPORTUNITY_PARTICIPANT_APPROVED_AT_SQL = `COALESCE(p.approved_at, p.matched_at, p.created_at)`;

/** Approved individuals today plus group size for groups linked today. */
export function opportunityTodayApprovedSeatsSql(opportunityIdExpr: string) {
  return `(
    (
      SELECT COUNT(*)::int
      FROM "opportunity-participant" p
      WHERE p.opportunity_id = ${opportunityIdExpr}
        AND p.status = 'APPROVED'
        AND (p.group_id IS NULL OR p.group_id = '')
        AND ${OPPORTUNITY_PARTICIPANT_APPROVED_AT_SQL} >= ${ISRAEL_DAY_START_SQL}
        AND ${OPPORTUNITY_PARTICIPANT_APPROVED_AT_SQL} < ${ISRAEL_DAY_END_SQL}
    )
    +
    (
      SELECT COALESCE(SUM(GREATEST(COALESCE("group"."size", 1), 1)), 0)::int
      FROM "group-opportunity" go
      JOIN "group" ON "group"."id" = go.group_id
      WHERE go.opportunity_id = ${opportunityIdExpr}
        AND go.created_at >= ${ISRAEL_DAY_START_SQL}
        AND go.created_at < ${ISRAEL_DAY_END_SQL}
    )
  )`;
}

/** Approved seats today across missions resolved to this partner organization. */
export function partnerOrganizationTodayApprovedSeatsSql(partnerIdExpr: string) {
  const childSeats = opportunityTodayApprovedSeatsSql("child.id");
  return `(
    SELECT COALESCE(SUM(${childSeats}), 0)::int
    FROM "opportunity" child
    LEFT JOIN "opportunity" parent ON parent.id = child.parent_opportunity_id
    WHERE child.is_deleted = false
      AND child.is_opportunity_group_parent = false
      AND COALESCE(child.partner_organization_id, parent.partner_organization_id) = ${partnerIdExpr}
  )`;
}

/** Mission daily target only. The partner-organization target does not block registration. */
export function opportunityDailyTargetReachedSql() {
  const seats = opportunityTodayApprovedSeatsSql(`"opportunity"."id"`);
  return `(
    "opportunity"."daily_volunteer_target" IS NOT NULL
    AND ${seats} >= "opportunity"."daily_volunteer_target"
  )`;
}

export function opportunityHasDailyVolunteerTargetSql() {
  return `("opportunity"."daily_volunteer_target" IS NOT NULL)`;
}

/** Feed: null target stays visible. A reached target drops the mission or occurrence. */
export function dailyVolunteerTargetStillOpenSql(tableAlias: string) {
  const seats = opportunityTodayApprovedSeatsSql(`${tableAlias}.id`);
  return `(
    ${tableAlias}.daily_volunteer_target IS NULL
    OR ${seats} < ${tableAlias}.daily_volunteer_target
  )`;
}

export function partnerOrganizationDailyTargetReachedSql() {
  const seats = partnerOrganizationTodayApprovedSeatsSql(
    `"partner-organization"."id"`,
  );
  return `(
    "partner-organization"."daily_volunteer_target" IS NOT NULL
    AND ${seats} >= "partner-organization"."daily_volunteer_target"
  )`;
}
